import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { LegendsComponent } from './home/legends/legends.component';
import { StatsComponent } from './home/stats/stats.component';
import { AboutusComponent } from './home/aboutus/aboutus.component';

// this constant default routes to Home, and also send all unknown path to Home
const routes: Routes = [
  { path: '', redirectTo: '/landing', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
{ path: 'legends', component: LegendsComponent },
{ path: 'statis', component: StatsComponent },
{ path: 'about', component: AboutusComponent },
{ path: '**', component: HomeComponent },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
